
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <b>Ihr Ratgeber «Der Ernährungskompass» ist eines der erfolgreichsten Sachbücher und wurde mehrfach ausgezeichnet. Sie haben dafür unzählige Ernährungsstudien ausgewertet. Wie viele waren es?</b><br />
So genau kann ich das nicht mehr sagen. Aber ich würde vermuten, es waren mehrere Tausend.
    <b>Was haben Sie herausgefunden?</b><br />
Ich versuchte, den Stand der Forschung der vergangenen Jahrzehnte zusammenzufassen. Was weiss die Wissenschaft über eine gesunde Ernährung? Am Ende fasste ich zwölf Regeln zusammen. Das wichtigste Fazit lautet: Essen Sie echtes Essen, also Nahrung, die auch Ihre Urgrossmutter noch als Nahrung erkannt hätte. In der Praxis heisst das, dass man so viel wie möglich selbst kochen sollte, mit möglichst unbehandelten Zutaten aus der Natur statt aus der Industrie.
    <b>Verraten Sie uns die fünf wichtigsten Tipps für eine gesunde Ernährung?</b><br />
Regel Nr. 1 hatten wir schon: Echtes Essen. Nr. 2: Mehr Pflanzliches, weniger Tierisches. Nr. 3: Lieber Fisch als Fleisch. Nr. 4: Bei den Milchprodukten lieber die fermentierten (Joghurt, Quark, Kefir), nicht die Milch selbst. Nr. 5: Keine generelle Angst vor Fett!
    <b>Der Auslöser für das Schreiben Ihres ersten Buches waren gesundheitliche Probleme. Was war los?</b><br />
Herzrhythmusstörungen, insbesondere beim Joggen und im Stress. Eines Tages ging ich joggen und musste mit einem massiven Stich in der Brust stehen bleiben. Ich hatte das Gefühl als würde eine Faust mein Herz packen und es fest und ruckartig zusammenpressen. Das war ziemlich beängstigend.
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;